module.exports = __webpack_public_path__ + "img/131.001672c3.jpg";